import clsx from "clsx";
import { Link } from "react-router-dom";

import { date, text, rightColHeader } from "../styles";
import { routesFlat } from "@routes";
import { RocketIcon } from "@assets/icons";

export default function Featured() {
    return (
        <>
            <div className={rightColHeader}>featured product update</div>
            <Link to={"/jmrv"}>
                <div className={clsx(date + " mt-2 tracking-wider")}>
                    Apr 16, 2026
                </div>
                <div className={clsx(text + " line-clamp-3")}>
                    Aboveground biomass data for 2001-2025 now available via Earthmover.
                </div>
            </Link>

            <Link to="/jmrv" className="mt-1 flex text-sm font-bold">
                <RocketIcon />
                <div className="ml-2 border-b-[1px] border-b-red">
                    Learn More
                </div>
            </Link>
        </>
    );
}
